/**
 * Canonical color tokens (FE-1 / D9).
 *
 * Single source for the brand palette. Consumers:
 * - `tailwind.config.js` requires this file (Tailwind loads it through jiti),
 *   so NativeWind classes like `bg-primary` use these values.
 * - `design-system/theme/reviewDesk.ts` and `design-system/theme/colors.ts`
 *   re-export from here for StyleSheet consumers.
 *
 * D9: the canonical brand blue is #2948B8 (the web shell's accent).
 *
 * Keep this file to plain object literals (no enums/namespaces) so it stays
 * loadable from the CommonJS Tailwind config.
 */

export const brand = {
  /** Canonical brand blue (D9). */
  primary: '#2948B8',
  primarySoft: '#EEF1FF',
  primaryWash: '#F7F8FF',
} as const;

/** Web-shell ("review desk") surface palette. */
export const surface = {
  canvas: '#F7F7F5',
  canvasMuted: '#EFEFEB',
  card: '#FFFEFB',
  cardMuted: '#F4F3EF',
  ink: '#101827',
  inkSoft: '#3F4654',
  muted: '#8A91A0',
  line: '#E2E6F0',
  lineStrong: '#C9D1E6',
  amber: '#E8A01A',
  amberSoft: '#FFF4D9',
  success: '#2F9A76',
  successSoft: '#EAF7F1',
  shadow: 'rgba(16, 24, 39, 0.12)',
} as const;
